import React from "react";
import { motion } from "framer-motion";
import { Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const categoryLabel = {
  theme: "Cake design à thème",
  wedding: "Wedding Cake",
  layer: "Layer Cake",
  number_letter: "Number / Letter Cake",
  cupcakes_entremets: "Cupcakes et entremets",
  number: "Number Cake",
  letter: "Letter Cake",
  cupcake: "Cupcakes",
  birthday: "Anniversaire",
  baptism: "Baptême",
  babyshower: "Baby Shower",
};

const FeaturedCakes = ({ cakes = [] }) => {
  const cakeItems = Array.isArray(cakes) ? cakes : [];
  if (cakeItems.length === 0) return null;

  return (
  <section className="py-24 bg-gradient-to-b from-[#FFF5F8] to-[#F6F7F1]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="h-px w-16 bg-[#D4AF37]" />
          <Sparkles className="w-5 h-5 text-[#D4AF37]" />
          <div className="h-px w-16 bg-[#D4AF37]" />
        </div>
        <h2 className="font-playfair text-3xl md:text-5xl font-bold text-gray-900 mb-4">
          Nos Créations
        </h2>
        <p className="text-gray-500 text-lg max-w-2xl mx-auto">
          Découvrez quelques-unes de nos réalisations les plus appréciées
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {cakeItems.map((cake, index) => (
          <motion.div
            key={cake.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="group"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-500">
              <div className="aspect-[4/5] overflow-hidden">
                <img src={cake.image} alt={cake.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500">
                <h3 className="font-playfair text-xl font-bold text-white mb-1">{cake.title}</h3>
                <p className="text-white/80 text-sm">{cake.description}</p>
              </div>
              <div className="absolute top-4 right-4 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-[#E5007D]">
                {categoryLabel[cake.category] || cake.category}
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="text-center mt-12">
        <Link
          to="/realisations"
          className="inline-flex items-center gap-2 px-8 py-4 bg-[#E5007D] text-white rounded-full font-medium text-sm hover:bg-[#c70069] transition-all duration-300 hover:shadow-lg hover:shadow-[#E5007D]/25"
        >
          Voir toutes les réalisations
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  </section>
  );
};

export default FeaturedCakes;
